import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import GlobalLoading from 'researcher/components/GlobalLoading';
import { redirectToCheckoutLink } from 'rubriq/helpers/emailCheckoutLink';

/**
 * Hands a checkout link from an email (`/:lang/rubriq/pay-link/:token`) back to megatron.
 *
 * Megatron owns the token: it works out whose checkout this is, asks Paddle for a transaction
 * and redirects on to the pay page. Nothing is decided here. Well-formed links never get this
 * far - `index.jsx` redirects them before the app mounts - so this only catches the rest, and
 * megatron answers those as an invalid link.
 */
var EmailCheckoutLinkRedirect = function EmailCheckoutLinkRedirect() {
  var _useParams = useParams(),
    token = _useParams.token;
  // React StrictMode invokes effects twice in development; one navigation is enough.
  var redirecting = useRef(false);
  useEffect(function () {
    if (redirecting.current) {
      return;
    }
    redirecting.current = true;
    redirectToCheckoutLink(token);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    robots: "noindex, nosnippet, noarchive",
    title: "Rubriq"
  }), /*#__PURE__*/React.createElement(GlobalLoading, {
    className: "position-relative"
  }));
};
export default EmailCheckoutLinkRedirect;